// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HkMEv","colMin":"styles_colMin__114Ye"};